<div class="content">
    <span>{{title}}</span>
</div>